import { useState } from 'react';
import type { SiteTemplate } from '../../schemas/validation';

export interface AdminTemplateManagerState {
  templates: SiteTemplate[];
  setTemplates: React.Dispatch<React.SetStateAction<SiteTemplate[]>>;
  privateTemplates: SiteTemplate[] | null;
  setPrivateTemplates: React.Dispatch<React.SetStateAction<SiteTemplate[] | null>>;
  showPrivate: boolean;
  setShowPrivate: (show: boolean) => void;
  currentPage: number;
  setCurrentPage: (page: number) => void;
  isLoadingPrivate: boolean;
  setIsLoadingPrivate: (loading: boolean) => void;
  isLoading: boolean;
  setIsLoading: (loading: boolean) => void;
  searchTerm: string;
  setSearchTerm: (term: string) => void;
  selectedTemplate: SiteTemplate | null;
  setSelectedTemplate: (template: SiteTemplate | null) => void;
  showEditModal: boolean;
  setShowEditModal: (show: boolean) => void;
  showDeleteModal: boolean;
  setShowDeleteModal: (show: boolean) => void;
  showPreviewPanel: boolean;
  setShowPreviewPanel: (show: boolean) => void;
  isSubmitting: boolean;
  setIsSubmitting: (submitting: boolean) => void;
  error: string | null;
  setError: (error: string | null) => void;
  successMessage: string | null;
  setSuccessMessage: (message: string | null) => void;
}

export const useAdminTemplateManagerState = (): AdminTemplateManagerState => {
  const [templates, setTemplates] = useState<SiteTemplate[]>([]);
  const [privateTemplates, setPrivateTemplates] = useState<SiteTemplate[] | null>(null);
  const [showPrivate, setShowPrivate] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [isLoadingPrivate, setIsLoadingPrivate] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const [searchTerm, setSearchTerm] = useState('');
  const [selectedTemplate, setSelectedTemplate] = useState<SiteTemplate | null>(null);
  const [showEditModal, setShowEditModal] = useState(false);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [showPreviewPanel, setShowPreviewPanel] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const [successMessage, setSuccessMessage] = useState<string | null>(null);

  return {
    templates,
    setTemplates,
    privateTemplates,
    setPrivateTemplates,
    showPrivate,
    setShowPrivate,
    currentPage,
    setCurrentPage,
    isLoadingPrivate,
    setIsLoadingPrivate,
    isLoading,
    setIsLoading,
    searchTerm,
    setSearchTerm,
    selectedTemplate,
    setSelectedTemplate,
    showEditModal,
    setShowEditModal,
    showDeleteModal,
    setShowDeleteModal,
    showPreviewPanel,
    setShowPreviewPanel,
    isSubmitting,
    setIsSubmitting,
    error,
    setError,
    successMessage,
    setSuccessMessage,
  };
};
